export default __webpack_public_path__ + "static/media/logo-full.2381bad9.png";